export enum OfferHeaderStyle 
{
    Small = 0,
    Medium = 1,
    Large = 2,
    Full = 3
}